import consts from 'constants/url';
import netpack from 'utils/netpack'
import actionConsts from 'constants/actions';
import { checkIfPresent } from 'utils/utilFunctions';
import analyticsUtil from 'utils/segmentUtil';

export const postMailReport = (payload, callback) => (dispatch) =>{
    netpack(consts.MAIL_REPORT).post({
        body: JSON.stringify(payload)
	}).then((response) => {
		if(response.success == 1) {
			//Segment integartion
			analyticsUtil.track("SEND_MAIL_SUCCESSFULL",{ body: payload });

			dispatch({
				type: actionConsts.SET_UI_STATE,
				payload: {
					isMailBeingSent: false,
					showMailStatusMessage: true,
					mailSentSuccessfully: true
				}
			});
		} else  {
			//Segment integartion
			analyticsUtil.track("SEND_MAIL_FAILED", { body: payload });
			
			dispatch({
				type: actionConsts.SET_UI_STATE,
				payload: {
					isMailBeingSent: false,
					showMailStatusMessage: true,
					mailSentSuccessfully: false
				}
			});
		}

		if(checkIfPresent(callback)) {
			callback();
		}
		setTimeout(() => {
			dispatch({
				type: actionConsts.SET_UI_STATE,
				payload: {
					isMailBeingSent: false,
					showMailStatusMessage: false,
					mailSentSuccessfully: false
				}
			});
		}, 5000);
	});
}